import React from "react";
import MainInput from "../../Elements/MainInput/MainInput";
import searchIcon from "../../../assets/icons/data/search.png";
import "./OffersSearchInput.css";

const OffersSearchInput = ({ value, onChange, placeholder }) => {
  return (
    <div className="offers-search-wrapper">
      <img src={searchIcon} alt="Search" className="offers-search-icon" />
      <MainInput value={value} onChange={onChange} placeholder={placeholder} />
    </div>
  );
};

export default OffersSearchInput;
